export const PHILIPPINE_REGIONS = [
  "NCR - National Capital Region",
  "CAR - Cordillera Administrative Region",
  "REGION I (Ilocos Region)",
  "REGION II (Cagayan Valley)",
  "REGION III (Central Luzon)",
  "REGION IV-A (CALABARZON)",
  "REGION IV-B (MIMAROPA)",
  "REGION V (Bicol Region)",
  "REGION VI (Western Visayas)",
  "REGION VII (Central Visayas)",
  "REGION VIII (Eastern Visayas)",
  "REGION IX (Zamboanga Peninsula)",
  "REGION X (Northern Mindanao)",
  "REGION XI (Davao Region)",
  "REGION XII (Soccsksargen)",
  "REGION XIII (Caraga)",
  "ARMM - Autonomous Region in Muslim Mindanao"
]



// WEBPACK FOOTER //
// ./src/utils/philippineRegions.js